const newArchivedGamePurchases = {
    gameID:  "77777777",   
    user: "studentxyz",        
    purchasesTable: [{
        itemName: "testing item purchased",
        itemType: "1000",
        itemCost: "500.00",
        enjoyWithFriendSw: true,
        imageURL: "testThis",
        imageDisplayHeight: "50%",
        imageDisplayWidth: "50%",
        canPurchaseMultipleSw: true,
        nbrTimesPurchased: "2",
        gameDateLastPurchased: "2024-08-12"
    }]
}

export default newArchivedGamePurchases;